import React from 'react'
import PlaceholderImage from 'components/PlaceholderImage'
import ReceiptViewHeader from './ReceiptViewHeader'
import ReceiptStatus from './ReceiptStatus'

import './ThankYouView.scss'
import { DropdownButton } from 'steps/referral/parts/DropdownButton2'

const ThankYouView = ({
  headline,
  bodyCopy,
  image,
  dropdownButtons,
  buttonTextColor,
}) => {
  const imageUrl =
    image && image.id ? `${process.env.SITE_ASSET_URL}/${image.id}` : null
  const alt = image && image.alt ? image.alt : ''

  return (
    <div className={`receipt-view thank-you-view`}>
      <ReceiptViewHeader headline={headline} introCopy={bodyCopy} />
      <div className={`receipt-view-content`}>
        <ReceiptStatus status="submitted" />
      </div>
      {imageUrl && (
        <div className={`receipt-view-header-image`}>
          <PlaceholderImage
            src={imageUrl}
            width={1490}
            height={624}
            className={''}
            alt={alt}
          />
        </div>
      )}
      {dropdownButtons && (
        <div className="receipt-view-buttons">
          {dropdownButtons.map((buttons, i) => (
            <div className="receipt-view-position">
              {buttons.links.length === 1 ? (
                <a
                  href={buttons.links[0].url}
                  key={i + '-b'}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="receipt-view-button"
                  // Addtional padding here to match the dropdown button
                  style={{
                    background: 'var(--text-color-primary)',
                    color: buttonTextColor,
                    padding: '15px 52.5px',
                  }}
                >
                  {buttons.links[0].label}
                </a>
              ) : (
                <DropdownButton
                  text={buttons.label}
                  items={buttons.links}
                  order={i}
                  color="var(--text-color-primary)"
                  textColor={buttonTextColor}
                  className="receipt-view-button"
                  showArrow={false}
                  noBoxShadow={true}
                />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
export default ThankYouView
